
var utils = {

    disableButtonOnSubmit: function () {
        if ($('form').valid() === true) {
            var elements = document.querySelectorAll('.submit-btn');
            for (var i = 0; i < elements.length; i++) {
                elements[i].disabled = true;

                var iEl = elements[i].querySelector('i');
                iEl.classList.add('d-none');

                var spanEl = elements[i].querySelector('span');
                spanEl.classList.remove('d-none');
            }
        }
    },

    toggleVisibility: function (selector, show) {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function (el) {
            if (show) {
                el.classList.remove('invisible');
                el.classList.add('visible');
            }
            else {
                el.classList.remove('visible');
                el.classList.add('invisible');
            }
        });
    },

    initDataTable: function (selector) {
        $(selector).DataTable({
            language: {
                url: '/lib/datatables/mx.json'
            },
            ordering: false,
            paging: false,
            scrollY: 400
        });
    },

    setCookie: function(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie: function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    eraseCookie: function (name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    removeAccents: function(data) {
        if (data.normalize) {
            return data + ' ' + data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
        return data;
    }

};